import {
    PerformanceBanner,
    PerformanceCondition,
    PerformanceTask,
} from '@strata/react-performance';
import { PerformanceStatusIndicator } from '@strata/react-status-indicators';

import { fmhNpiAPI, PERFORMANCE_API_URL } from 'api/APIBase';

export interface PerformanceRequirement {
    performance_requirement_id: string;
    referral_id: string;
    value_case_id: string;
    value_case_name: string;
    value_case_description: string;
    performance_start_date: string;
    performance_end_date: string;
    evaluation_end_date: string;
    status: (typeof PerformanceStatusIndicator.Statuses)[keyof typeof PerformanceStatusIndicator.Statuses];
    incentive: number;
    banners: PerformanceBanner[];
    tasks: PerformanceTask[];
}

/** Gets performance entries associated with a referral */
export function getPerformanceByReferralId({
    npi,
    referralId,
}: {
    npi: string;
    referralId: string;
}) {
    const url = `${PERFORMANCE_API_URL}/referral/${referralId}`;
    return fmhNpiAPI({ url, npi }).get().json<PerformanceRequirement[]>();
}

/** Updates a performance condition */
export function savePerformanceConditions({
    npi,
    referralId,
    conditions,
}: {
    npi: string;
    referralId: string;
    conditions: PerformanceCondition[];
}) {
    const url = `${PERFORMANCE_API_URL}/${referralId}/conditions`;
    return fmhNpiAPI({ url, npi }).put(conditions).json<PerformanceRequirement[]>();
}

/* Performance files */

export async function getPerformanceFile({
    npi,
    referralId,
    conditionId,
    filename,
}: {
    npi: string;
    referralId: string;
    conditionId: string;
    filename: string;
}) {
    const url = `${PERFORMANCE_API_URL}/files/${npi}/${referralId}/${conditionId}/${filename}`;
    return fmhNpiAPI({ url, npi }).get().blob();
}

export async function postPerformanceFile({
    npi,
    referralId,
    conditionId,
    file,
}: {
    npi: string;
    referralId: string;
    conditionId: string;
    file: File;
}) {
    const url = `${PERFORMANCE_API_URL}/files/${npi}/${referralId}/${conditionId}`;
    return fmhNpiAPI({ url, npi }).formData({ file }).post().json();
}

export async function deletePerformanceFile({
    npi,
    referralId,
    conditionId,
    filename,
}: {
    npi: string;
    referralId: string;
    conditionId: string;
    filename: string;
}) {
    const url = `${PERFORMANCE_API_URL}/files/${npi}/${referralId}/${conditionId}/${filename}`;
    return fmhNpiAPI({ url, npi }).delete().json();
}
